"use strict";

angular.module("core")
.filter("isEmptyObject", function() {
    return function(value) {
        if (typeof value!=="object" || value === null) {
            return false;
        } else {
            return Object.keys(value).length === 0;
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/is-empty/is-empty.filter.js
// module id = 369
// module chunks = 0